module.exports = __webpack_public_path__ + "img/contactIMG.4a0c5720.png";